import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { AuthService } from './services/auth.service';
import {SecurityCacheService} from './services/security-cache.service';
import {HttpResponseHandlerService} from './services/http-response-handler.service';
import {BuSelectionService} from './services/bu-selection.service';
import { DispatcherService } from '../shared/services/dispatcher/dispatcher.service';

@NgModule({
    declarations: [
    ],
    providers: [
    ],
    imports: [
    ],
    exports: [
    ]
})
export class AuthCoreModule {

    constructor( @Optional() @SkipSelf() parentModule: AuthCoreModule) {
        if (parentModule) {
            throw new Error(
                'AuthCoreModule is already loaded. Import it in the AppModule only');
        }
    }

    static forRoot(): ModuleWithProviders<AuthCoreModule> {
        return {
            ngModule: AuthCoreModule,
            providers: [
                AuthService,
                SecurityCacheService,
                HttpResponseHandlerService,
                BuSelectionService,
                DispatcherService
            ]
        };
    }
}
